import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SAVE_FILE: createActionType(FULL_NAMESPACE, "SAVE_FILE"),
    SAVE_FILE_COMPLETE: createActionType(FULL_NAMESPACE, "SAVE_FILE_COMPLETE"),
    API_VOICE_RECOGNITION: createActionType(FULL_NAMESPACE, "API_VOICE_RECOGNITION"),
    API_VOICE_RECOGNITION_COMPLETE: createActionType(FULL_NAMESPACE, "API_VOICE_RECOGNITION_COMPLETE")
};
